import { Middleware } from 'redux';
import { validateMOQRequest } from '../actions/MOQ/validateMOQAction';

const moqValidationMiddleware: Middleware = store => next => (action) => {
  const result = next(action);

  const triggerActions = [
    'GET_BASKET_RESPONSE',
    'GET_BASKET_ERROR',
    'UPDATE_BASKET_RESPONSE',
    'UPDATE_BASKET_ERROR',
    'POST_ORDER_RESPONSE',
    'POST_ORDER_ERROR',
    'POST_AMEND_ORDER_RESPONSE',
    'POST_AMEND_ORDER_ERROR',
    'UPLOAD_ORDER_CSV_RESPONSE',
    'UPLOAD_ORDER_CSV_ERROR',
    'UPDATE_ORDER_STATUS_RESPONSE',
    'UPDATE_ORDER_STATUS_ERROR',
  ];

  if (triggerActions.includes(action.type)) {
    setTimeout(() => {
      store.dispatch(validateMOQRequest());
    }, 0);
  }

  return result;
};

export default moqValidationMiddleware;
